/**
 * Determine whether dark mode color scheme preference is enabled on client machine
 */
export function isDarkModePreferred(): boolean {
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
}